import React from "react";
import { Row } from "antd";

export default function PrintHeader(props) {
  return (
    <div className="print_header">
      <Row type="flex" justify="space-between">
        <div className="logo">
          <img src="\logo.png" alt="Logo" />
        </div>
        <div>
          <p>Elitex Systems LP</p>
          <p>39/5 Granton Crescent,</p>
          <p>Edinburgh, United Kingdom,</p>
          <p>EH5 1BN</p>
          <a href="http://elitex.systems/">http://elitex.systems/</a>
        </div>
      </Row>
      {props.groupBy ? (
        <div>
          <strong>Group by:</strong> {props.groupBy}
        </div>
      ) : null}
      <div>
        <strong>Period:</strong> {props.startDate} {props.fromYear} - {props.endDate}{" "}
        {props.toYear}
      </div>
    </div>
  );
}
